module.exports = __webpack_public_path__ + "images/db-logos/scylla.png";